<template>
  <div class="Loader">
    <div class="Bar"></div>
    <div class="Bar"></div>
    <div class="Bar"></div>
  </div>
</template>

<script>
export default {
  name: 'appLoader'
}
</script>

<style scoped lang="scss">
@import '../assets/_vars';

.Loader {
	height: 32px;
	width: 42px;
	position: relative;
  border-radius:3px;
  padding:4px;
	
	.Bar {
		background: $lightBlue;
		height: 0;
		position: absolute;
		bottom: 0;
		width: 10px;
		
		@for $i from 0 through 3 {
			&:nth-child(#{$i}) {
				left: ($i * 16px) - 16px;
				animation: bottom-top 1s infinite cubic-bezier(0.4, 0.0, 0.2, 1) ($i * 0.2s);
			}
		}
	}
}

@keyframes bottom-top {
	0% {
		height: 0;
		opacity: 0;
	}
	
	50% {
		height: 30px;
		opacity: 1;
	}
	
	100% {
		height: 0;
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/appLoader.vue